import clsx from "clsx";
import styles from "./style.module.scss";

interface IProps {
  message: string | React.ReactNode;
  position?: "left" | "center" | "right" | "down";
  children: React.ReactNode;
  wrapperClass?: string;
}

export default function Tooltip({
  message,
  position = "center",
  wrapperClass,
  children
}: Readonly<IProps>) {
  const getWrapperClassByPosition = () => {
    switch (position) {
      case "left":
        return "right-0 pl-3 -mr-1.5";
      case "right":
        return "left-0 pr-3 -ml-1.5";
      case "down":
        return "top-10";
      default:
        return "left-1/2 -translate-x-1/2 px-3";
    }
  };

  const getTailClassByPosition = () => {
    switch (position) {
      case "left":
        return "right-0 mr-0.5";
      case "right":
        return "left-0 ml-0.5";
      case "down":
        return "top-0 mr-2";
      default:
        return "";
    }
  };

  return (
    <div className={clsx(styles.tooltipContainer, "group")}>
      <div
        className={clsx(styles.wrapper, getWrapperClassByPosition(), "group-hover:scale-100 z-90")}>
        <div className={clsx(styles.body, wrapperClass, "drop-shadow-[0_4px_4px_#A6A0A040]")}>
          <div className={styles.messageWrapper}>{message}</div>
          <div className={clsx(styles.tail, getTailClassByPosition())}></div>
        </div>
      </div>
      {children}
    </div>
  );
}
